import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { MastheadPortalId } from '../../../models/AdminModels';
import { useAdminAccountQuery } from '../../../queries/Admin/Account/useAdminAccountQuery';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { CollectPayment } from '../../components/tools/CollectPayment';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

const styles = StyleSheet.create({
	accountHeader: {
		backgroundColor: '#f8f9fa',
		borderBottom: '1px solid #e9ecef',
		marginBottom: 16,
		padding: '12px 16px',
	},
	accountName: {
		color: '#212529',
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
	},
	accountLabel: {
		color: '#6c757d',
		fontSize: 12,
		marginBottom: 4,
	},
});

export const AdminCollectPaymentPage: React.FC = () => {
	const { pricebookItemId, accountId } = useParams<{ pricebookItemId: string; accountId?: string }>();

	const accountQuery = useAdminAccountQuery({
		accountId: accountId || '',
		enabled: !!accountId,
	});

	const accountName = accountQuery.data?.companyName;

	const pathComponentNameProvider = React.useCallback(
		(pathComponent: string) => {
			if (pathComponent === accountId && accountName) {
				return accountName;
			}
			if (pathComponent === 'collect-payment') {
				return 'Collect Payment';
			}
			// Hide pricebook item ID from breadcrumbs
			if (pathComponent === pricebookItemId) {
				return null;
			}
			return undefined;
		},
		[accountId, accountName, pricebookItemId]
	);

	return (
		<AdminDashboardPageLayout>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar pathComponentNameProvider={pathComponentNameProvider} />
			</Portal>
			{accountId && accountName && (
				<div className={css(styles.accountHeader)}>
					<div className={css(styles.accountLabel)}>Collecting Payment for Account</div>
					<h2 className={css(styles.accountName)}>{accountName}</h2>
				</div>
			)}
			<CollectPayment />
		</AdminDashboardPageLayout>
	);
};
